import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "historical-data",
    iconColor: "white",
    text: "Multiple views in\n a single place",
    listItemCustomStyle: { width: "auto" },
  },
  {
    icon: "deep-dive",
    iconColor: "white",
    text: "End-to-end view of \nthe complete order",
    listItemCustomStyle: { width: "auto" },
  },
  {
    icon: "cost-reduction",
    iconColor: "white",
    text: "Reduction in OPEX cost",
    listItemCustomStyle: { width: "auto" },
  },
  {
    icon: "like-finger",
    iconColor: "white",
    text: "Maximize customer\ndelight",
    listItemCustomStyle: { width: "auto" },
  },
];

const DATA_BENEFITS_IEAM_1 = {
  title: "END-TO-END PROCESS VISBILITY",
  titleNumber: "1.",
  text: "Providing visualization of order, along with hierarchy and its progression \nacross the multiple components. This gives the operations team near\n real-time view on the overall progression, along with any failure points.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ILO_103"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_101"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_Introduction_02.png",
};

export default DATA_BENEFITS_IEAM_1;
